// import { HeadingTitle ,SubHeadingTitle,Image} from '../../../../components/shared/index'
// import styles from './wallet.module.css'
// const Wallet = () => {
//   return (
//   <section className={styles.wallet__wrapper}>
//       <div className={styles.emptyState}>
//         <Image
//          src={"/assets/img/backgrounds/wallet.png"}
//          alt="Empty wallet"
//           className={styles.walletImage} />
//         <HeadingTitle text='Your wallet is empty!' style={styles.title}/>
//         <SubHeadingTitle subTitle="Look like there are no transactions in your wallet at the moment."
//         style={styles.description}/>
//       </div>
//     </section>
//   )
// }

// export default Wallet

import React from 'react'

const Wallet = () => {
  return (
    <div>
       Wallet
    </div>
  )
}

export default Wallet
